<template>
  <div class="add-family-wrap">
    <CommonHead title="添加家庭成员"></CommonHead>
    <div class="fanily-main">
      <van-form validate-first label-width="120px" input-align="right" @submit="submit">
        <van-field
            v-model="formData.name"
            error
            required
            label="真实姓名"
            placeholder="请输入真实姓名"
            :error-message="errMsg.username"
        />
        <van-field name="radio" error required label="性别">
          <template #input>
            <div class="formInput" >
              <div :class="['formitem',{formActive:formData.gender == item.type}]" v-for="item in sexList" :key="item.type" @click="onChangeSex(item)">
                <span> {{item.title}} </span>
              </div>
            </div>
          </template>
        </van-field>
        <van-field
            v-model="formData.idCardNo"
            error
            required
            label="身份证"
            placeholder="请输身份证证件号码"
            :error-message="errMsg.idcard"
        />
        <van-field name="switch" error required label="关系">
          <template #input>
           亲属 &nbsp; <van-switch v-model="switchChecked" size="20" @change="onChangeSwitch" />
          </template>
        </van-field>


        <div class="btn-box">
          <van-button v-show="!selectedProfile" round block type="info" native-type="submit">确认</van-button>
        </div>
      </van-form>

    </div>

    <van-popup v-model="selectedProfile" round  position="bottom" :style="{ maxHeight: '70%',background: '#F6F8FA' }" >
      <div class="vacc-cont">
        <div class="pop-title"><b>档案检索结果</b></div>

        <van-radio-group v-model="vaccId">
          <div :class="['vaccpop', {vaccActive: item.id == vaccId}]" v-for="(item,index) in vaccList" :key="index" >
            <div class="vaccleft">
              <div class="row-top">
                <b> {{item.name}} </b>
                <div class="poptag"> <span> {{ item.gender }} </span> </div>
<!--                <div class="poptag poptagwo"> <span> {{ '女' }} </span> </div>-->
                  <div class="poptag">{{item.age}}</div>
              </div>
              <div class="popbot"><span> {{item.idCardNo}} </span></div>
              <div class="popbot"> <span> {{`档案单位： ${item.povName}`}} </span> </div>
            </div>
            <div class="vacc-right">
              <van-radio :name="item.profileId" @click='radioChange(item.profileId)'/>
            </div>

          </div>
        </van-radio-group>
        <div class="poptip"><span>若信息均不正确，请前往门诊修改所要添加成员的信息</span></div>
        <div class="pop-btn">
          <van-button round block type="default" @click="onCancel">取消</van-button>
          <van-button round block type="info"  @click="sendProfileAuth" >请求档案授权</van-button>
        </div>

      </div>

    </van-popup>

    <div class="fill-iphone-safe-area"></div>


  </div>
</template>
<script>
import CommonHead from "components/CommonHead";
import { addFamilyRecord,requestRecord } from "api/user";
import { Toast } from 'vant';
export default {
  name: 'AddFamily',
  components: {
    CommonHead
  },
  data() {
    return {
      formData: {
        name: '',
        gender: 1,
        idCardNo: ''
      },
      errMsg:{
        username:'',
        idcard:''
      },
      //判断能否请求档案
      isProfile:false,
      sexList: [{title: '男', type: 1},{title: '女', type: 2}],
      switchChecked: true,
      selectedProfile: false,
      vaccList:[
        // {name: '张三',idcard: '342424958686*****',address: '北京市东城区xxxx',id: 1},
        // {name: '李四',idcard: '342424958686*****',address: '北京市东城区xxxx',id: 2}
      ],
      vaccId: 1,
     profileId:''

    }
  },
  methods: {
    submit() {
     
      if(!this.formData.name){
       this.errMsg.username='请填写姓名'
      }else{
        this.errMsg.username=''
      }
      if(!this.formData.idCardNo){
        this.errMsg.idcard='请填写身份证号'
      }else{
        this.errMsg.idcard=''
      }
      console.log(this.formData)
      if(this.formData.name && this.formData.idCardNo){
        console.log(111)
          addFamilyRecord(this.formData).then(resp=>{
        this.vaccList=resp.data
         this.selectedProfile = !this.selectedProfile;
         if(resp.data.length>0){
          this.isProfile=true
         }else{
          this.isProfile=false
          Toast.fail("暂未查询到人员")
          this.selectedProfile=false
         }
      })
      }
    
      
    },
    unSelectProfile() {

    },
    radioChange(val){
      console.log(val)
      this.profileId=val
    },
    onChangeSex(item) {
      this.formData.gender = item.type;
    },
    onChangeSwitch(e) {
      console.log(e)
      this.switchChecked = e;
    },
    onCancel() {
      this.selectedProfile = !this.selectedProfile;
    },
    sendProfileAuth() {
    console.log(111)
    if(this.isProfile){
requestRecord({profileId:this.profileId}).then(resp=>{
        if(resp.code==0){
        this.$router.push({path: '/my-family'})
        }else{
          
          Toast.fail(resp.message)
        }
        
      })
    }
      
    }


  }
}
</script>
<style lang="less" scoped>
.add-family-wrap {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  background: #FFFFFF;

  .fanily-main {
    padding: 10px 15px;

    ::v-deep {
      .van-cell--required::before {
        color: #FB625F;
      }
      //.van-field--error .van-field__control,
      .van-field--error .van-field__control::placeholder {
        color: #999999;
      }
    }

    .formInput {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .formitem {
        width: 56px;
        line-height: 30px;
        text-align: center;
        margin-left: 15px;
        border: 1px solid #50A0FF;
        font-size: 13px;
        color: #50A0FF;
        border-radius: 3px;
      }
      .formActive {
        background: #50A0FF;
        color: #FFFFFF;
      }
    }
    .btn-box {
      box-sizing: border-box;
      padding: 20px 30px;
      width: 100%;
      position: fixed;
      bottom: 20px;
      z-index: 2;
      button {
        border: 0;
        margin-bottom: 20px;
        background: #50A0FF;
      }
    }

  }
  .vacc-cont {
    width: 100%;
    box-sizing: border-box;
    padding: 12px 13px;

    .pop-title {
      margin-bottom: 15px;
    }

    .vaccpop {
      width: 100%;
      box-sizing: border-box;
      margin-bottom: 20px;
      background: #FFFFFF;
      padding: 10px;
      border: 2px solid #FFFFFF;
      border-radius: 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .row-top {
        font-weight: bold;
        opacity: .9;
        margin-bottom: 11px;
        display: flex;
        align-items: center;

        b {
          color: #50A0FF;
          margin-right: 8px;
          font-size: 13px;
          line-height: 20px;
        }
        .poptag {
          width: 36px;
          line-height: 17px;
          text-align: center;
          border: 1px solid #50A0FF;
          border-radius: 5px;
          font-size: 11px;
          color: #50A0FF;
        }
        .poptagwo {
          border-color: #FF884D;
          color: #FF884D;
        }
      }
      .popbot {
        font-size: 13px;
        color: #666666;
        margin: 10px 0;
      }

    }
    .vaccActive {
      border-color: #4689FF;
    }
    .poptip {
      font-size: 11px;
      color: #50A0FF;
      text-align: center;
      margin-top: 30px;
    }

    .pop-btn {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 15px;
      padding-bottom: 15px;
      button {
        width: 45%;
        padding: 0;
      }
    }



  }



}

</style>